<template>
    <div>
        <div class="container-sm mt-5">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="scss">
    .icon {
        width: 100px;
        height: 100px;
        border: 0px solid #111;
        border-radius: 15px;
        -moz-border-radius: 15px;
        -webkit-border-radius: 15px;
    }
</style>
